import React from 'react';

export const FlagCAIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 600 300" // Standard 2:1 ratio
    {...props}
  >
    <rect width="600" height="300" fill="#FFFFFF" rx="2"/> {/* White field */}
    <rect width="150" height="300" fill="#FF0000" /> {/* Red bar left */}
    <rect x="450" width="150" height="300" fill="#FF0000" /> {/* Red bar right */}
    {/* Maple Leaf */}
    <path
      fill="#FF0000"
      d="M300 50 L325 120 L270 115 L285 155 L225 150 L250 190 L210 200 L300 250 L390 200 L350 190 L375 150 L315 155 L330 115 L275 120 Z"
    />
  </svg>
);